import React from 'react';
import { motion } from 'framer-motion';
import { BrainCircuit } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 relative bg-brand-darker border-y border-white/5 overflow-hidden pt-[10px] pb-[10px]" data-id="element-95">
      {/* Subtle gold glow behind */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-gold/5 blur-[100px] rounded-full pointer-events-none" data-id="element-96" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-98">
          <div className="inline-flex items-center justify-center p-4 rounded-full bg-brand-gold/10 mb-8 box-glow-gold" data-id="element-99">
            <BrainCircuit className="w-10 h-10 text-brand-gold" data-id="element-100" />
          </div>

          <h2 className="text-3xl md:text-4xl font-black text-brand-white uppercase tracking-tight mb-8" data-id="element-101">
            El Mecanismo Único: <br className="hidden md:block" data-id="element-102" />
            <span className="text-brand-gold text-glow-gold" data-id="element-103">
              Ayuno de Dopamina Digital™
            </span>
          </h2>

          <p className="text-xl text-brand-gray leading-relaxed max-w-3xl mx-auto" data-id="element-104">
            Aprenderás a tratar el rastro digital de tu ex como una sustancia
            prohibida, forzando a tu cerebro a sanar en 30 días mediante la
            eliminación total de disparadores visuales y emocionales.
          </p>
        </motion.div>
      </div>
    </section>;
}